/// <amd-module name="Wiki/Overview/OverviewDialogHandler" />
import { IVssPageContext } from "VSS/Platform/Context";

import { showWrappedDialog } from "Wiki/ViewCommon/WrappedDialogHelper";

export function showDeletePageDialog(pageContext: IVssPageContext, props: { [propertyName: string]: any }): void {
    showWrappedDialog(pageContext, { ...props }, "Wiki.DeletePageDialog", ["ms.vss-wiki-web.wiki-deletepage-dialog-content"]);
}

export function showMovePagePanel(pageContext: IVssPageContext, props: { [propertyName: string]: any }): void {
    showWrappedDialog(pageContext, { ...props }, "Wiki.PageMovePanel", [
        "ms.vss-wiki-web.wiki-pagemove-panel-content",
        "ms.vss-wiki-web.search-location-include"
    ]);
}

export function showLinkWorkItemPanel(pageContext: IVssPageContext, props: { [propertyName: string]: any }): void {
    showWrappedDialog(pageContext, { ...props }, "Wiki.LinkWitPanel", ["ms.vss-wiki-web.wiki-linkwit-content"]);
}

export function showMoveConfirmationDialogOrPanel(
    pageContext: IVssPageContext,
    brokenLinksProps: { [propertyName: string]: any },
    simpleConfirmationDialogProps: { [propertyName: string]: any },
    isBrokenLinksEnabled?: boolean
): void {
    if (isBrokenLinksEnabled) {
        showWrappedDialog(pageContext, { ...brokenLinksProps }, "Wiki.PageRenamePanel", [
            "ms.vss-wiki-web.page-rename-panel-content",
            "ms.vss-wiki-web.search-location-include"
        ]);
    } else {
        showWrappedDialog(pageContext, { ...simpleConfirmationDialogProps }, "Wiki.MovePageConfirmationDialog", [
            "ms.vss-wiki-web.wiki-move-page-confirmation-dialog-content"
        ]);
    }
}
